import { render } from "./Access.vue?vue&type=template&id=73a32928"
const script = {}

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__